/**
 * Lazy-load da section de recomendações (fetch por data-url ao entrar no viewport).
 * Depende de global.js + base.js (teamdropInitProductCards) + product.js (utilities).
 */
function fetchAndInject(container) {
  var url = container.dataset.url;
  if (!url) return;

  fetch(url)
    .then(function (r) {
      return r.text();
    })
    .then(function (html) {
      var div = document.createElement("div");
      div.innerHTML = html;
      var n = div.querySelector(".product-recommendations");
      if (!n || !n.innerHTML.trim().length) return;

      container.innerHTML = n.innerHTML;
      if (theme && theme.utilities) {
        if (theme.utilities.applyAnimation) {
          theme.utilities.applyAnimation();
        }
        if (theme.utilities.applyImagesSrcset) {
          theme.utilities.applyImagesSrcset();
        }
      }
      teamdropInitProductCards(container);
    })
    .catch(function (err) {
      console.error(err);
    });
}

function bind(container) {
  if (!container || container.dataset.teamdropPrBound === "true") return;
  container.dataset.teamdropPrBound = "true";

  new IntersectionObserver(
    function (entries, observer) {
      if (!entries[0] || !entries[0].isIntersecting) return;
      observer.unobserve(container);
      fetchAndInject(container);
    },
    { rootMargin: "0px 0px -15% 0px" }
  ).observe(container);
}

function mountRecommendationRoots(root) {
  (root || document).querySelectorAll(".product-recommendations").forEach(bind);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    mountRecommendationRoots(document);
  });
} else {
  mountRecommendationRoots(document);
}

document.addEventListener("shopify:section:load", function (event) {
  if (!event.target) return;
  var el = event.target.querySelector(".product-recommendations");
  if (el) {
    delete el.dataset.teamdropPrBound;
    bind(el);
  }
});
